module.exports = __webpack_public_path__ + "img/ball_3_green.69dea2c9.png";